<template>
  <div class="navigation-buttons">
    <v-tooltip bottom :disabled="disableTooltips">
      <template slot="activator" slot-scope="{ on, attrs }">
        <v-btn
          class="nav-btn prev-btn"
          icon
          :disabled="prevDisabled"
          v-bind="attrs"
          tabindex="-1"
          v-on="on"
          @click="$emit('prev')"
        >
          <v-icon large>
            mdi-chevron-left
          </v-icon>
        </v-btn>
      </template>
      <span>
        {{ $t(prevTooltipI18nKey) }}
        <span class="dialog-edge-nav-shortcut">
          <span class="shortcut-key-badge">Alt</span>
          <v-icon x-small class="dialog-edge-nav-shortcut__plus">
            mdi-plus
          </v-icon>
          <v-icon x-small class="dialog-edge-nav-shortcut__arrow">
            mdi-chevron-left
          </v-icon>
        </span>
      </span>
    </v-tooltip>
    <v-tooltip bottom>
      <template slot="activator" slot-scope="{ on, attrs }">
        <v-btn
          class="nav-btn next-btn"
          icon
          :disabled="nextDisabled"
          v-bind="attrs"
          tabindex="-1"
          v-on="on"
          @click="$emit('next')"
        >
          <v-icon large>
            mdi-chevron-right
          </v-icon>
        </v-btn>
      </template>
      <span>
        {{ $t(nextTooltipI18nKey) }}
        <span class="dialog-edge-nav-shortcut">
          <span class="shortcut-key-badge">Alt</span>
          <v-icon x-small class="dialog-edge-nav-shortcut__plus">
            mdi-plus
          </v-icon>
          <v-icon x-small class="dialog-edge-nav-shortcut__arrow">
            mdi-chevron-right
          </v-icon>
        </span>
      </span>
    </v-tooltip>
  </div>
</template>

<script>
/**
 * 결함 정보 다이얼로그 등: 화면 좌우 가장자리 이전/다음 네비게이션.
 * 부모 v-dialog 직하위에 v-carousel.dialog-edge-navigation-carousel 으로 감싸 사용.
 */
export default {
  name: 'DialogEdgeNavigation',
  props: {
    /** true 이면 툴팁 비활성화 (다이얼로그 닫힘 등) */
    disableTooltips: {
      type: Boolean,
      default: false
    },
    prevDisabled: {
      type: Boolean,
      default: false
    },
    nextDisabled: {
      type: Boolean,
      default: false
    },
    prevTooltipI18nKey: {
      type: String,
      default: 'defects.previousImage'
    },
    nextTooltipI18nKey: {
      type: String,
      default: 'defects.nextImage'
    },
    /** true 일 때 Alt+← / Alt+→ 단축키 등록 */
    keyboardActive: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    keyboardActive: {
      immediate: true,
      handler(val) {
        if (val) {
          this.attachKeyboard();
        } else {
          this.detachKeyboard();
        }
      }
    }
  },
  beforeDestroy() {
    this.detachKeyboard();
  },
  methods: {
    attachKeyboard() {
      if (this._keyboardBound) return;
      document.addEventListener('keydown', this.onDocumentKeydown);
      this._keyboardBound = true;
    },
    detachKeyboard() {
      if (!this._keyboardBound) return;
      document.removeEventListener('keydown', this.onDocumentKeydown);
      this._keyboardBound = false;
    },
    onDocumentKeydown(event) {
      if (!this.keyboardActive) return;
      if (!event.altKey) return;
      if (event.code === 'ArrowLeft' && !this.prevDisabled) {
        event.preventDefault();
        this.$emit('prev');
      }
      if (event.code === 'ArrowRight' && !this.nextDisabled) {
        event.preventDefault();
        this.$emit('next');
      }
    }
  }
};
</script>

<style scoped>
.navigation-buttons {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  transform: translateY(-50%);
  pointer-events: auto;
}

.nav-btn {
  background-color: var(--v-surface-base) !important;
  margin: 0 20px;
}

.nav-btn:hover {
  filter: brightness(1.05);
}

.nav-btn.v-btn--disabled {
  opacity: 0.45 !important;
}

.dialog-edge-nav-shortcut {
  display: inline-flex;
  align-items: center;
  margin-left: 4px;
}

.dialog-edge-nav-shortcut__plus,
.dialog-edge-nav-shortcut__arrow {
  margin: 0 1px;
}

.shortcut-key-badge {
  background: color-mix(in srgb, var(--v-secondary-base) 22%, var(--v-surface-base));
  padding: 1px 4px;
  border-radius: 2px;
  margin: 0 1px;
  font-size: 10px;
}
</style>

<style>
/* 부모 템플릿의 v-carousel 에 함께 지정 */
.dialog-edge-navigation-carousel {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
}
</style>
